/* BackToProjectBanner — when an admin clicks a contact / task / inspection /
   measurement chip from inside ProjectDetail, we attach `?fromProject={id}`
   to the URL. Pages that might receive an admin from a project mount this
   banner; it reads the param and renders a sticky "Back to Project" pill so
   the admin is one click away from where they came from. */

import { useSearchParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackToProjectBanner() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const projectId = params.get("fromProject");
  if (!projectId) return null;
  return (
    <div className="sticky top-0 z-30 flex justify-center px-2 pt-2 pointer-events-none">
      <button
        type="button"
        onClick={() => navigate(`/projects/${projectId}`)}
        className="pointer-events-auto inline-flex items-center gap-2 rounded-full bg-[#0F4C81] text-white text-sm font-medium px-4 py-2 shadow-lg hover:bg-[#0D4270] transition-colors"
        data-testid="back-to-project-banner"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to project
      </button>
    </div>
  );
}
